/* Home v4 (apontamento 12, 28/10): logos monocromáticos nas abas de marca de Roupas.
   O motor da vitrine (hit-home.js, navegaRoupas) cria cada aba só com o nome da marca. Aqui o botão ganha o logo (mesmo componente de
   "Navegue por marcas": .hit-logo) e o nome continua no botão como texto: some da vista quando o logo carrega e volta se a imagem falhar.
   O mapa marca -> logo vem da própria seção, em <script type="application/json" data-roupas-logos> (chave: vendor em minúscula). */
(() => {
  'use strict';
  if (window.HitHomeV4) return;
  window.HitHomeV4 = true;

  const lerLogos = (raiz) => {
    const no = raiz.querySelector('[data-roupas-logos]');
    if (!no) return {};
    try { return JSON.parse(no.textContent) || {}; } catch (_) { return {}; }
  };

  const decora = (botao, logos) => {
    if (botao.dataset.logoFeito) return;
    botao.dataset.logoFeito = '1';
    const nome = botao.textContent.trim();
    const logo = logos[nome.toLowerCase()];
    if (!logo || !logo.src) return;
    const caixa = document.createElement('span');
    caixa.className = 'hit-logo' + (logo.ko ? ' is-ko' : '');
    caixa.setAttribute('aria-hidden', 'true');
    const img = document.createElement('img');
    img.alt = ''; img.width = 96; img.height = 28; img.decoding = 'async'; img.src = logo.src;
    const texto = document.createElement('span');
    texto.className = 'hit-logo__nome';
    texto.textContent = nome;
    img.addEventListener('error', () => { botao.classList.remove('tem-logo'); img.hidden = true; });
    caixa.appendChild(img);
    botao.replaceChildren(caixa, texto);
    botao.classList.add('tem-logo');
  };

  const observa = (raiz) => {
    const barra = raiz.querySelector('[data-roupas-abas]');
    if (!barra || barra.dataset.logosObservada) return;
    barra.dataset.logosObservada = '1';
    const logos = lerLogos(raiz);
    const passa = () => barra.querySelectorAll('button').forEach((b) => decora(b, logos));
    new MutationObserver(passa).observe(barra, { childList: true });
    passa();
  };

  const inicia = () => document.querySelectorAll('[data-home-roupas]').forEach(observa);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
  document.addEventListener('shopify:section:load', inicia);
})();
